import { SVGAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

export function ErrorIcon({ width = 24, height = 24, className, ...rest }: SVGAttributes<SVGElement>) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      {...rest}
      className={twMerge('', className)}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity={0.12}
        d="M9.23 5.783l-5.45 9.414c-.912 1.576-1.368 2.364-1.3 3.01a2 2 0 00.813 1.41C3.819 20 4.729 20 6.55 20h10.9c1.82 0 2.731 0 3.257-.382a2 2 0 00.813-1.41c.068-.647-.389-1.435-1.3-3.011l-5.45-9.414c-.91-1.57-1.364-2.355-1.957-2.619a2 2 0 00-1.626 0c-.593.264-1.047 1.05-1.956 2.62z"
        fill="#22282F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.508 3.85a1.25 1.25 0 00-1.016 0c-.108.048-.274.173-.552.567-.277.391-.598.944-1.06 1.742l-5.45 9.414c-.464.8-.785 1.356-.986 1.792-.204.44-.23.647-.218.765.036.352.221.673.508.881.095.07.288.15.77.194.479.044 1.12.045 2.046.045h10.9c.925 0 1.567 0 2.046-.045.482-.044.675-.124.77-.194a1.25 1.25 0 00.508-.881c.013-.118-.014-.325-.218-.765-.201-.436-.522-.992-.986-1.792l-5.45-9.414c-.462-.798-.783-1.35-1.06-1.742-.279-.394-.444-.52-.552-.567zm-1.625-1.371a2.75 2.75 0 012.234 0c.485.216.844.614 1.167 1.071.322.454.677 1.068 1.115 1.825l.02.033 5.45 9.413.018.033c.44.76.797 1.375 1.03 1.882.237.51.404 1.02.35 1.55a2.75 2.75 0 01-1.119 1.938c-.43.313-.956.424-1.515.475-.556.051-1.267.051-2.145.051H6.512c-.878 0-1.59 0-2.145-.05-.56-.052-1.085-.163-1.515-.476a2.75 2.75 0 01-1.118-1.939c-.055-.529.112-1.04.348-1.55.234-.506.59-1.121 1.03-1.881l.02-.033 5.45-9.413.019-.033c.438-.757.793-1.37 1.114-1.825.324-.457.683-.855 1.168-1.071zM12 8.25a.75.75 0 01.75.75v4a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zM12 17a1 1 0 100-2 1 1 0 000 2z"
        fill="#EF364F"
      />
    </svg>
  );
}
